{
  "actions": {
    "add": "Legg til",
    "open": "Åpne",
    "openType": "Åpne {{type, lowercase}}",
    "edit": "Redigere",
    "remove": "Fjerne",
    "abort": "Avbryt",
    "close": "Lukk",
    "create": "Ny",
    "createNew": "Opprett ny {{documentType}}",
    "search": "Søk",
    "sort": "Sortere",
    "sortBy": "Sortere etter {{label}}",
    "presetSort": "Forhåndsinnstilt sortering",
    "grouping": "Velg gruppering",
    "nogrouping": "Ingen gruppering",
    "group": "Gruppe",
    "copy": "Kopiere",
    "confirm": "Ferdig",
    "markAsDone": "Legg som klar",
    "move": "Flytte",
    "yes": "Ja",
    "no": "Nei",
    "approve": "Godkjenn",
    "saveType": "Lagre {{type}}",
    "save": "Lagre",
    "publish": "Publiser"
  },
  "misc": {
    "unknown": "ukjent",
    "user": "bruker",
    "numberOf": "Antall",
    "from": "Fra",
    "new": "Ny",
    "selected": "valgt",
    "since": "siden",
    "missing": "Mangler",
    "loading": "Laster inn...",
    "titleMissing": "Tittel mangler",
    "fetchingSession": "Henter sesjon...",
    "fetchingUserData": "Henter brukerdata...",
    "headingAndContent": "Overskrift og innhold",
    "markedAsCancelled": "Merket som avlyst",
    "error": "Feil",
    "selectTime": "Velg tid",
    "searching": "Søker...",
    "nothingFound": "Ingenting ble funnet"
  }
}
